import styled from "styled-components";
import { calculateResponsiveSize } from "helpers/calculateResponsiveSize";
import { mediaMax } from "helpers/mediaQueries";

export const ImageWrapper = styled.div`
  display: grid;
  width: 72.5%;
  ${mediaMax("tabletLandscape")} {
    width: 100%;
  }
`;

export const ImageItem = styled.div`
  grid-area: 1/1;
  transition: opacity 1s;
  background: #47505a;
  &.entering,
  &.entered {
    opacity: 1;
  }
  &.exiting,
  &.exited {
    opacity: 0;
  }
`;

export const InfoContent = styled.div`
  grid-area: 1/1;
  transition: opacity 1s;
  &.entering,
  &.entered {
    opacity: 1;
  }
  &.exiting,
  &.exited {
    opacity: 0;
  }
  ${mediaMax("desktopSm")} {
    margin-top: 24px;
    grid-row: 2;
  }
`;

export const InfoWrapper = styled.div`
  display: grid;
  width: 27.5%;
  justify-items: start;
  align-content: start;
  padding: 0 ${calculateResponsiveSize(60)};
  ${mediaMax("tabletLandscape")} {
    padding: 0 20px;
    width: 100%;
  }
`;

export const Logo = styled.div``;

export const ControlButtons = styled.div`
  display: flex;
  margin-bottom: ${calculateResponsiveSize(60)};
  ${mediaMax("desktopSm")} {
    margin: -15px 0 24px;
    grid-row: 1;
  }
`;
export const ControlButton = styled.button`
  width: ${calculateResponsiveSize(48)};
  height: ${calculateResponsiveSize(4)};
  margin-right: ${calculateResponsiveSize(6)};
  background: ${({ $color }) => ($color === "white" ? `#fff;` : "#1E1E1E;")};
  opacity: 0.25;
  border: 0;
  cursor: pointer;
  &.active {
    opacity: 1;
  }
  ${mediaMax("desktopSm")} {
    width: 46px;
    height: 4px;
  }
  ${mediaMax("tabletLandscape")} {
    background: ${({ $mobileColor }) =>
      $mobileColor === "dark" ? `#1E1E1E;` : "#fff;"};
    margin-right: 5px;
  }
`;

export const SliderItem = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  padding-bottom: ${calculateResponsiveSize(120)};

  &.park-section {
    background-color: #e7e4d5;
  }
  &.club-36th-floor-section {
    padding-top: ${calculateResponsiveSize(120)};
  }
  &.extra-padding {
    padding-bottom: ${calculateResponsiveSize(240)};
  }
  ${mediaMax("tabletLandscape")} {
    flex-direction: column;
    &:nth-of-type(odd) {
      padding-left: 66px;
    }
    &:nth-of-type(even) {
      padding-right: 66px;
    }
  }
`;
